import React, { useEffect, useRef, useState } from 'react'
import { Layout, Input, notification } from 'antd'
import { withTranslation } from 'react-i18next'
import pageService from '../../Common/Page/pageService'
import Sound from '../../Sound'
import { dispatch } from '../../../system/store'
import { error as errorSound, success } from '../../Sound/actions'
import apiService from '../../Warehouse/apiService'
function AddWarehouseShelf(props) {
    const { t } = props
    const { warehouse, warehouse_shelf } = props.match.params
    const [loading, setLoading] = useState(false)
    const [packageInput, setPackageInput] = useState('')
    const inputRef = useRef(null)
    useEffect(() => {
        handleFocusInput()
        pageService.setTitle(t(''), <Sound />)
    }, [])

    const handleScan = () => {
        if (!packageInput.trim()) {
            handleFocusInput()
            return
        }

        setLoading(true)
        apiService
            .confirmStowing(warehouse, warehouse_shelf, { package_ids: [packageInput] })
            .then(res => {
                notification.success({ message: 'Quét mã thành công!' })
                dispatch(success())
            })
            .catch(e => {
                notification.error({ message: t('package:message.scan_to_stowing.input_error') })
                dispatch(errorSound({ type: 'SCAN_BARCODE_FORM.FAILED', message: '' }))
            })
            .finally(() => {
                setLoading(false)
                handleFocusInput()
            })
    }

    const handleFocusInput = () => {
        setPackageInput('')
        if (inputRef.current) {
            inputRef.current.focus()
        }
    }
    return (
        <Layout>
            <Layout.Content
                style={{
                    padding: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                }}>
                <div
                    style={{
                        width: '100%',
                        background: '#fff',
                        padding: 24,
                        borderRadius: 8,
                        boxShadow: '0 0 8px rgba(0,0,0,0.05)',
                    }}>
                    <Input
                        ref={inputRef}
                        value={packageInput}
                        placeholder="Quét vào mã kiện"
                        onChange={e => setPackageInput(e.target.value)}
                        onPressEnter={handleScan}
                    />
                </div>
            </Layout.Content>
        </Layout>
    )
}
export default withTranslation()(AddWarehouseShelf)
